import { FBA_AMAZON_COST_COMPARISON } from '../../data/fbaPrepPricingData';
import './FbaAmazonCostComparison.css';

export default function FbaAmazonCostComparison() {
  return (
    <section className="fba-amazon-compare" aria-labelledby="fba-amazon-compare-heading">
      <div className="fba-amazon-compare-head">
        <p className="fba-amazon-compare-eyebrow">Cost comparison</p>
        <h2 id="fba-amazon-compare-heading" className="fba-amazon-compare-title">
          Amazon FBA Fees vs Pick Pack Pro Prep Costs
        </h2>
        <p className="fba-amazon-compare-lead">
          Choosing the right Amazon FBA prep solution can have a significant impact on your margins. While Amazon charges fulfilment and storage fees, a specialist UK Amazon prep centre helps reduce preparation costs, improve inventory visibility and ensure your products arrive fulfilment-ready. The comparison below highlights the key differences between Amazon's fulfilment network and Pick Pack Pro's transparent FBA prep services.
        </p>
      </div>

      <div className="fba-amazon-compare-scroll" role="region" aria-label="Amazon FBA vs prep centre cost comparison" tabIndex={0}>
        <table className="fba-amazon-compare-table">
          <caption className="fba-amazon-compare-caption">
            Amazon FBA fees compared with Pick Pack Pro FBA prep centre costs for UK sellers
          </caption>
          <thead>
            <tr>
              <th scope="col">Cost factor</th>
              <th scope="col">Amazon FBA</th>
              <th scope="col">Pick Pack Pro prep</th>
            </tr>
          </thead>
          <tbody>
            {FBA_AMAZON_COST_COMPARISON.map((row) => (
              <tr key={row.factor}>
                <th scope="row">{row.factor}</th>
                <td>{row.amazon}</td>
                <td>{row.ppp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
